export const calculateRedemptionValue = (item) => {
  if (item.deal?.customAmount === true) {
    return item?.redemptionInputValue ?? 0;
  } else {
    return (item?.redemptionInputValue ?? 0) / 100;
  }
};
